import {
  global_danger_color_100 as dangerColor,
  global_danger_color_100 as dangerColorLight,
  global_success_color_200 as successColor,
  global_disabled_color_100 as unknownColor,
  global_warning_color_200 as warningColor,
  global_warning_color_100 as warningColorLight,
} from "@patternfly/react-tokens";

export const SUCCESS = successColor.var;
export const ERROR = dangerColor.var;
export const ERROR_LIGHT = dangerColorLight.var;
export const UNKNOWN = unknownColor.var;
export const WARNING = warningColor.var;
export const WARNING_LIGHT = warningColorLight.var;

export const DARKEN_WHITE = "#d1d1d1";
